<template>
  <div class="pageContent">
    <!--顶部一条-->
    <mu-appbar>
      <span class="topT">他人代付</span>
      <!--返回上一层-->
      <mu-icon value="keyboard_arrow_left" color="white" style="margin-bottom: -0.05rem" slot="left" v-on:click="goback" />
  
      <mu-icon value="keyboard_arrow_left" color="#27ba69" slot="right" />
    </mu-appbar>
  
    <div style="width:100% ; margin-top:0.3rem" align="center">
      <textarea style="resize: none; width:92% ; height:5.2rem ;  font-size:0.22rem ; padding:0.15rem ; background-color:#F6F6F6 " readonly=""
       id="gxx1">{{ payURL }} </textarea>
  
      <!--{{  g_PayOrder.OrderId   }}-->
  
      <mu-raised-button data-clipboard-target="#gxx1" label="双击选中后手动复制" v-on:click="Copy" primary="" v-bind:style="{ width:'92%', height:'0.8rem' }" style="font-size: 0.3rem ; margin-top:0.2rem ;   " />
  
  
    </div>
  
    <!--弹出框-->
    <mu-toast v-if="toast" :message="TellUser" @close="hideToast" id="alertline" />
  
  </div>
</template>








<script>

import { mapMutations, mapGetters } from 'vuex'
import api from '../../api'



export default {
  computed: {
    ...mapGetters([
      'g_UserInfo', 'g_PayOrder'
    ])
  },
  activated() {
    this.getURL();
  },
  data() {
    return {


      // 弹出层
      toast: false,
      // 弹出标签 选择是否
      dialog: false,

      payURL: '',
      TellUser:''

    }
  },
  methods: {
    goback() {
      javascript: history.go(-1);
    },

    getURL() {
      this.payURL = '';
      var params = new this.URLSearchParam();
      params.append('parentNo', this.g_PayOrder.OrderId);
      if(this.$route.query.type){
        params.append('orderType',this.$route.query.type)
      }
      this.$http.post(api.GetPayUrl(), params.toParam()).then((res) => {
        console.log(res)

        if (res.Result) {
          this.payURL = res.Data;
        }
        else {
          //调用弹出层
          this.TellUser = res.Message;
          this.showToast();
        }
      })
    },




    Copy() {

      var Url2 = document.getElementById("gxx1");
      Url2.select() 
      setTimeout(() => { Url2.select() }, 100)

      // var clipBoardContent=document.getElementById("gxx1").Html;
      // if(navigator.userAgent.toLowerCase().indexOf('ie') > -1) {
      //   clipboardData.setData('Text',clipBoardContent);
      //   alert ("已经复制到您的剪贴板中\n\n您可以使用粘贴到浏览器中打开！");
      // } else {
      //   prompt("请复制网址:",clipBoardContent);
      // }

      // var Url2 = document.getElementById("gxx1");
      // setTimeout(() => { Url2.select() }, 100)
      // setTimeout(() => { Url2.select() }, 150)
      // setTimeout(() => { this.payURL= new Date }, 800)


      // var Url2 = document.getElementById("gxx1");
      // Url2.select()
      // Url2.touchstart()  
      // setTimeout(() => { Url2.select() }, 150)
      // setTimeout(() => { this.payURL= new Date }, 800)
      



      // setTimeout(() => {  }, 80)
      // setTimeout(() => { Url2.select() }, 100)
      // setTimeout(() => { Url2.select() }, 200)
      // setTimeout(() => { Url2.select() }, 300)
      // setTimeout(() => { Url2.select() }, 150)

      // document.execCommand("Copy"); // 执行浏览器复制命令
    },

    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1500)
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end
    // 弹出标签 选择是否
    open() {
      this.dialog = true
    },
    closeYES() {
      this.dialog = false;
      //调用弹出层
      this.showToast();
    },
    closeNO() {
      //  拒绝取消订单
      this.dialog = false;
    },
    // END 弹出标签 选择是否

  },





}
</script>




// paper模块
<style lang="less" scoped>
@import "../../assets/theme.less";
.demo-paper {
  // 横向显示
  /*display: inline-block;*/
  margin: 8px;
  text-align: center;
  margin-top: 10px;
}

.green {
  color: @primaryColor ;
  border: 1px solid @primaryColor ;
}

.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;

  color: @textColor; // 顶部标签变换
  .header {
    width: 100%
  }
  .mu-tabs {
    // 背景色
    background-color: #fff;
  } // 未选中时候的颜色
  .mu-tab-link {
    color: #999999;
    font-weight: bold;
  } //  选中  分页的
  .mu-tab-active {
    color: @primaryColor;
    font-weight: bold;
  } // END 顶部标签变换
  .Orange {
    color: @primaryOrange ;
  }
  .Black {
    color: @primaryBlack ;
  }
  .Grey {
    color: @textColor;
  }
}
</style>





// WEBPACK FOOTER //
// PayByOther.vue?9f749ac4